import { Project } from '@prisma/client';
import { Row } from '@tanstack/react-table';
import {
  Button,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@zond/ui';
import { Edit, MoreHorizontal, Pencil, Settings, Trash2 } from 'lucide-react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import { useProjects } from '../context';

interface DataTableRowActionsProps {
  row: Row<Project>;
}

export default function DataTableRowActions({ row }: DataTableRowActionsProps) {
  const { t } = useTranslation('projects');
  const { setOpen, setCurrentRow } = useProjects();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navigate = useNavigate();
  const { workspaceId } = useParams();

  const handleMenuOpenChange = (open: boolean) => {
    setIsMenuOpen(open);
  };

  return (
    <DropdownMenu open={isMenuOpen} onOpenChange={handleMenuOpenChange}>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" className="h-8 w-8 p-0">
          <span className="sr-only">{t('rowActions.openMenu')}</span>
          <MoreHorizontal className="h-4 w-4" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuItem
          onClick={() => {
            navigate(`/${workspaceId}/projects/${row.original.id}`);
            setIsMenuOpen(false);
          }}
        >
          {t('rowActions.viewDetails')}
        </DropdownMenuItem>
        <DropdownMenuItem
          onClick={() => {
            setCurrentRow(row.original);
            setOpen('edit');
            setIsMenuOpen(false);
          }}
        >
          {t('rowActions.quickEdit')}
        </DropdownMenuItem>
        <DropdownMenuSeparator />
        <DropdownMenuItem
          onClick={() => {
            setCurrentRow(row.original);
            setOpen('delete');
            setIsMenuOpen(false);
          }}
          className="text-red-600"
        >
          <Trash2 className="mr-2 h-4 w-4" />
          {t('common:actions.delete')}
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
